<template>
  <PrescriptionResultPage :config="config" />
</template>

<script>
import PrescriptionResultPage from '@/components/smallComponents/PrescriptionResultPage.vue'

export default {
  components: { PrescriptionResultPage },
  data() {
    return {
      config: {
        pageTitle: '处方信息确认',
        showSymptoms: true,
        showGanZhiLabel: true,
        priceApi: '/api/health/v1/price',
        redirectRoute: '/Prescription',
      },
    }
  },
}
</script>
<style scoped>
</style>
